module.exports = __webpack_public_path__ + "media/images/sales/early/arrow-down-71b6f445c0ea015565085399001c92e6.svg";